<template>
  <b-modal
    id="refer-modal"
    centered
    ref="refer-modal"
    title="Share and Earn"
    hide-footer
  >
    <div class="wrapper">
      <b-row>
        <b-col cols="12" class="mb-4">
          <p class="text-dark">
            Share your referral link or code to people. Remember, you earn
            {{ userObj.is_stakeholder ? "10%" : "5%" }}
            for every one you refer
          </p>
          <div class="referral-link">
            <b-input-group>
              <b-form-input
                id="ref-link"
                :value="refLink"
                type="text"
                :disabled="true"
              ></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" @click="handleCopyLink"
                  >Copy</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-col>
        <b-col cols="12">
          <social-sharing
            class="row no-gutters"
            :url="refLink"
            title="Interested in real estate investment? Invest as low as N50,000 for returns as high as 50% in 18 months. #realestate #investment #highreturns #guaranteed"
            description="Interested in real estate investment? Invest as low as N50,000 for returns as high as 50% in 18 months. #realestate #investment #highreturns #guaranteed"
            quote="Interested in real estate investment? Invest as low as N50,000 for returns as high as 50% in 18 months. #realestate #investment #highreturns #guaranteed"
            twitter-user="pertinencegroup"
            inline-template
          >
            <div>
              <network class="col-6 col-md-3 square mb-2" network="facebook">
                <div class="wrapper p-2">
                  <b-button
                    variant="white"
                    class="bg-white action-btn p-4 text-center w-100 h-100"
                  >
                    <i class="fab fa-facebook icon-fx m-0"></i>
                  </b-button>
                </div>
              </network>
              <network class="col-6 col-md-3 square mb-2" network="twitter">
                <div class="wrapper p-2">
                  <b-button
                    variant="white"
                    class="bg-white action-btn p-4 text-center w-100 h-100"
                  >
                    <i class="fab fa-twitter icon-fx m-0"></i>
                  </b-button>
                </div>
              </network>
              <network class="col-6 col-md-3 square mb-2" network="whatsapp">
                <div class="wrapper p-2">
                  <b-button
                    variant="white"
                    class="bg-white action-btn p-4 text-center w-100 h-100"
                  >
                    <i class="fab fa-whatsapp icon-fx m-0"></i>
                  </b-button>
                </div>
              </network>
              <network class="col-6 col-md-3 square mb-2" network="linkedin">
                <div class="wrapper p-2">
                  <b-button
                    variant="white"
                    class="bg-white action-btn p-4 text-center w-100 h-100"
                  >
                    <i class="fab fa-linkedin icon-fx m-0"></i>
                  </b-button>
                </div>
              </network>
            </div>
          </social-sharing>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "refer-modal",
  methods: {
    handleCopyLink() {
      var copyText = document.getElementById("ref-link");

      /* Select the text field */
      copyText.disabled = false;
      copyText.select();
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/

      /* Copy the text inside the text field */
      document.execCommand("copy");
      copyText.disabled = true;
      this.$store.dispatch("toast", {
        message: "Copied successfully"
      });
    }
  },
  computed: {
    ...mapState(["userObj"]),
    refLink() {
      return `https://app.realvest.ng/r/${this.userObj.referralcode}`;
    }
  }
};
</script>
<style lang="scss" scoped>
@media (max-width: 768px) {
  #ref-link {
    padding: 0.4em;
  }
}
</style>
